import React from "react"

import BookingPolicy from "@/components/public/venue/booking_policy"
import { type GetPublicReservationQuery } from "@/graphql/graphql"
import i18n from "@/i18n"
import { buildBookingPolicyTiles } from "@/shared/booking_policy"

const STYLES = {
  container: "bg-white px-5 py-5",
  title: "text-[16px] font-medium tracking-[-0.5px] text-[#171717] mb-3",
} as const

type Venue = NonNullable<GetPublicReservationQuery["public"]["reservation"]>["venue"]

type Props = {
  venue: Venue
}

const ReservationRulesCard: React.FC<Props> = ({ venue }) => {
  const config = venue.reservationConfiguration
  const venueInfo = venue.info
  const bookingPolicySection = venue.reservationRuleSections?.find((s) => s.identifier === "booking_policy")

  const bookingPolicyTiles = config
    ? buildBookingPolicyTiles({
        availableBookingPolicyTiles: config.availableBookingPolicyTiles,
        bookingPolicyTiles: config.bookingPolicyTiles,
        minReservationTime: config.minReservationTime,
        maxReservationTime: config.maxReservationTime,
        noshowAutoCancelAfter: config.noshowAutoCancelAfter,
        largeGroupThreshold: config.largeGroupThreshold,
        cancellationDeadline: config.cancellationDeadline,
        phone: venueInfo?.phone,
        email: venueInfo?.email,
      })
    : []

  const hasBookingPolicy = bookingPolicyTiles.length > 0 || !!bookingPolicySection?.content?.trim()

  if (!hasBookingPolicy) return null

  return (
    <div className={STYLES.container}>
      <div className={STYLES.title}>{i18n.t("app.public.reservation.reservation_rules")}</div>
      <BookingPolicy
        tiles={bookingPolicyTiles}
        content={bookingPolicySection?.content}
        embedded={true}
        hideTitle={true}
      />
    </div>
  )
}

export default ReservationRulesCard
